import Link from "@mui/material/Link";

export const faqListStaff = [
  {
    question:
      "How do I contact customer support if I have a question or issue?",
    answer: (
      <>
        You can reach our customer support team by emailing{" "}
        <Link
          underline="none"
          sx={{ color: "primary.main" }}
          href={`mailto:support@peterdrew.com`}
        >
          support@peterdrew.com
        </Link>{" "}
        or calling{" "}
        <Link
          underline="none"
          sx={{ color: "primary.main" }}
          href="tel:+441789774777"
        >
          01789 774777
        </Link>
        .
      </>
    ),
  },
  {
    question: "How do I place a Uniform Request?",
    answer: (
      <>
        To place a Uniform Request, click on the "New Request" button on the
        sidebar, or the "Start Request" button on the dashboard.
        <br />
        <>
          To add items to the order, follow these steps:
          <ol>
            <li>
              Browse through the available items and select the ones you need.
            </li>
            <li>
              Click on the "Add to Order" button next to each item you want to
              include.
            </li>
            <li>
              If your quantity exceeds your entitlement, you will be asked to
              provide a reason.
            </li>
            <li>Review your selected items in the order summary.</li>
            <li>
              Once you have added all the necessary items, proceed to submit
              your order for approval.
            </li>
          </ol>
        </>
      </>
    ),
  },
  {
    question: "What do I do if my uniform does not fit?",
    answer: (
      <>
        Please contact your line manager or uniform purchaser to return the
        items.
      </>
    ),
  },
  {
    question: "What is a Draft Request?",
    answer: (
      <>
        A Draft Request is a request that has been started but not yet submitted
        for approval. Requests are automatically saved, you can return to it
        later to complete and submit.
      </>
    ),
  },
  {
    question: "Can I cancel a Uniform Request?",
    answer: (
      <>
        You can cancel a request that has not yet been approved. To cancel a
        Uniform Request, navigate to the "Submitted Requests" section, then
        click on the red trash can icon next to the request you wish to cancel.
      </>
    ),
  },
  {
    question: "How do I edit a submitted Uniform Request?",
    answer: (
      <>
        Once submitted a request cannot be edited. If you need to make changes
        to a request that has already been submitted, please contact your line
        manager or uniform purchaser.
      </>
    ),
  },
  {
    question: "How long does it take for my request to be approved?",
    answer: (
      <>
        The time for a request to be approved is dependent on the approvers
        within your company. If your request is urgent, please contact your line
        manager or uniform purchaser. Please let them know the request number
        starting with "DF".
      </>
    ),
  },
  {
    question: "My request has been rejected, what do I do?",
    answer: (
      <>
        Please contact your line manager or uniform purchaser to discuss the
        reasons for the rejection.
      </>
    ),
  },
  {
    question: "How can I see the status of my approved requests?",
    answer: (
      <>
        You can view the status of your request by clicking on the "Request
        History" button on the dashboard. Here you will see all your Approved
        Requests, once an approved request has been shipped it moves to the
        Completed Requests section.
      </>
    ),
  },
  {
    question: "How do I update my account details or password?",
    answer: (
      <>
        Please navigate to the "My Account" section on the dashboard to update
        your personal details and password.
      </>
    ),
  },
];
